'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Editable = require('apollo-cms/lib/DataView/Object/Editable');

var _Editable2 = _interopRequireDefault(_Editable);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var EditableObject = (_temp = _class = function (_EditableView) {
  _inherits(EditableObject, _EditableView);

  function EditableObject() {
    _classCallCheck(this, EditableObject);

    return _possibleConstructorReturn(this, _EditableView.apply(this, arguments));
  } // static defaultProps = {
  //   ...EditableView.defaultProps,
  // }


  EditableObject.prototype.getTextField = function getTextField(props) {
    var inEditMode = this.isInEditMode();
    var disabled = props.disabled;

    if (disabled === undefined && !inEditMode) {
      Object.assign(props, {
        disabled: true
      });
    }

    return _EditableView.prototype.getTextField.call(this, props);
  };

  EditableObject.prototype.setPageMeta = function setPageMeta(meta) {
    var _props = this.props,
        setPageMeta = _props.setPageMeta,
        object = _props.data.object;

    if (setPageMeta) {
      setPageMeta(object);
    }
  };

  EditableObject.prototype.componentDidMount = function componentDidMount() {
    var data = this.props.data;

    var _ref = data || {},
        loading = _ref.loading,
        refetch = _ref.refetch; // console.log("componentDidMount loading", loading);

    /**
     * Если при монтировании загрузка не выполняется,
     * это значит, документ из кеша взять. Надо перезагрузить данные
     */


    if (loading === false && refetch) {
      refetch();
    }

    _EditableView.prototype.componentDidMount && _EditableView.prototype.componentDidMount.call(this);
  };

  EditableObject.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    this.setPageMeta();
    _EditableView.prototype.componentDidUpdate && _EditableView.prototype.componentDidUpdate.call(this, prevProps, prevState);
  };

  return EditableObject;
}(_Editable2.default), _class.propTypes = _extends({}, _Editable2.default.propTypes, {
  setPageMeta: _propTypes2.default.func
}), _temp);
exports.default = EditableObject;
module.exports = exports['default'];